import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { Access } from "@/graphql/types";
import { useRoleColumns } from "./useRoleColumns";


export default /*#__PURE__*/_defineComponent({
  __name: 'RoleDefaults',
  props: {
    access: {}
  },
  setup(__props: any) {



const { columns, accessText } = useRoleColumns();

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, { value: _ctx.access }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), (col, index) => {
        return (_openBlock(), _createBlock(_component_Column, {
          field: col.field,
          header: col.header,
          key: `roles-col-default-${index}`
        }, {
          body: _withCtx(({ data, field }) => [
            _createTextVNode(_toDisplayString(_unref(accessText)(data[field])), 1)
          ]),
          _: 2
        }, 1032, ["field", "header"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})